import React, { Component, cloneElement,useState, useEffect } from 'react';
import { List, downloadCSV, ExportButton, Datagrid, SelectInput, TextField, DateField, BooleanField, ShowButton, Filter, TextInput, GET_ONE, GET_MANY, TopToolbar, RefreshButton, usePermissions,useResourceContext, useRecordContext } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../../src/spinner';
import myDataProvider from '../myRestProvider';
import FormattedCurrencyNumberCustom from '../formatted-currency-number-custom';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common'
import Modal from 'react-responsive-modal';
import { render } from 'react-dom';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useLocation } from 'react-router-dom';

const BusinessesFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" />
    <TextInput source="phone" defaultValue="" />
    <TextInput source="sap_code" label="Sold To ID" defaultValue="" />
    <SelectInput source="is_ordering_blocked" label="Ordering Blocked" choices={[
      { id: true, name: 'True' },
      { id: false, name: 'False' },
    ]} />
  </Filter>
);

const PostPanel = (props) => {

  const [open, setOpen] = useState(false);
  const [showloader, setShowloader] = useState(true);
  const [reloadButton, setReloadButton] = useState(false);
  const [data, setData] = useState({});
  const [dateFlag, setDateFlag] = useState(false);
  const [showModalForZambiaTanzania, setShowModalForZambiaTanzania] = useState(false);
  const [showModalForOtherCountries, setShowModalForOtherCountries] = useState(false);
  const [last_sap_update, setLast_sap_update] = useState('')
  const record = useRecordContext();
  console.log("props BusinessList ",record);

  useEffect(() => {
    fetchItem(props?.id)
    if (props?.permissions === "isJDE") {
      setShowModalForZambiaTanzania(true);
      // this.setState({
      //   showModalForZambiaTanzania: true,
      // });
    } else {
      setShowModalForOtherCountries(true);
      // this.setState({
      //   showModalForOtherCountries: true,
      // });
    }
  }, [])

  const reload = () => {
    setReloadButton(false);
    setShowloader(true);
    // this.setState(
    //   {
    //     reloadButton: false,
    //     showloader: true,
    //   },
    //   () => this.fetchItem(this.props.id)
    // );
  }
  const fetchItem = async (id) => {
    setShowloader(true);
    // this.setState({ showloader: true });
    const json = await myDataProvider(GET_ONE, "getSapDetails", { id });
    const item = json.data;
    console.log("items are", item);
    setShowloader(false);
    setData(item);
    // this.setState({
    //   showloader: false,
    //   data: item,
    // });
    if (item && item.errorMsg === "Reload") {
      // reloadButton = true;
      setReloadButton(true)
    }
    var countryTime = new Date(
      data && data.last_sap_update
    ).toLocaleString("en-US");
    console.log("countryTime", countryTime);
    setLast_sap_update(countryTime)
    // this.setState({ last_sap_update: countryTime });
    if (last_sap_update !== "Invalid Date") {
      // this.state.last_sap_update = "sd"
      setDateFlag(true)
      // this.setState({ dateFlag: true });
    }
  };

    return (
      <div className="soldToDetails">
        <table>
          <tr>
          </tr>
          {showModalForZambiaTanzania &&
            <div>
              <tr>
                <th>Payment term</th>
                <th>OutStanding Payments</th>
                <th>Credit Limit</th>
                <th>Paid-In Amount</th>
                <th>Credited Amounts</th>
                <th>Invoiced Amounts</th>
                <th>Open Orders Amount</th>
                <th>Amount owed between 1-30 days</th>
                <th>Over 30 days</th>
                <th>Available Balance</th>
              </tr>
              <tr>
                <td>{data.payment_terms ? data.payment_terms : ''}</td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.outstanding_payments ? data.outstanding_payments : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.credit_limit ? data.credit_limit : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.paid_in_amount ? data.paid_in_amount : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.credited_amounts ? data.credited_amounts : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.invoiced_amount_not_yet_paid ? data.invoiced_amount_not_yet_paid : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.orders_not_invoiced_price ? data.orders_not_invoiced_price : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.current_and_1_to_30_days ? data.current_and_1_to_30_days : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.over_30_days ? data.over_30_days : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.sap_digital_order_balance ? data.sap_digital_order_balance : 0
                    }
                  />
                </td>
              </tr>
            </div>
          }
          {showModalForOtherCountries &&
            <div>
              <tr>
                <th>SAP credit area Cd</th>
                <th>Last SAP update</th>
                <th>Currency</th>
                <th>Credit limit</th>
                <th>Credit exposure SAP</th>
                <th>Credit exposure LOGON</th>
                <th>Open credit LOGON</th>
                <th>Orders not invoiced price</th>
                <th>Digital order balance</th>
              </tr>
              <tr>
                <td>{data.sap_credit_area_cd ? data.sap_credit_area_cd : ''}</td>
                <td >{dateFlag && last_sap_update}</td>
                <td>{data.currency ? data.currency : ''}</td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.credit_limit ? data.credit_limit : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.credit_exposure_sap ? data.credit_exposure_sap : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.credit_exposure_logon ? data.credit_exposure_logon : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.open_credit_logon ? data.open_credit_logon : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.orders_not_invoiced_price ? data.orders_not_invoiced_price : 0
                    }
                  />
                </td>
                <td>
                  <FormattedCurrencyNumberCustom
                    value={
                      data.sap_digital_order_balance ? data.sap_digital_order_balance : 0
                    }
                  />
                </td>
              </tr>
            </div>
          }
          <tr>
            <td className='errorMsg' colspan="9">{reloadButton && window.navigator.onLine &&
              <div>{data.msgText}</div>
            }</td>
          </tr>
          <tr>
            <td className='spinner' colspan="9"><div className="spinner">
              {showloader && window.navigator.onLine &&
                <Spinner />
              }
            </div>
              {reloadButton && window.navigator.onLine &&
                <div className="refresh" >
                  <i onClick={reload} className="material-icons">
                    refresh
                       </i>
                </div>
              }
              <div>
                {!window.navigator.onLine &&
                  <p>It seems that you are offline. Please check your internet connection</p>
                }
              </div>
            </td>
          </tr>
        </table>
      </div>
    )

}

// const ListActions = (props) => {
//   const [modalShow, setModalShow] = React.useState(false);
//   const [modalMsg, setModalMsg] = React.useState('');
//   const [customFilterUrl, setCustomFilterUrl] = React.useState('filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D');
//   const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//   const csvResource = resource + '_csv'
//   const options = CommonHeaderOption();
//   const apiUrl = RUN_TIME_API_ENDPOINT;

//   const callExport = (e) => {
//     e.preventDefault();
//     console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//     options.method = 'GET';
//     let _url = window.location.href.split('?');
//     if (_url.length > 1 && _url[1] !== '') {
//       console.log('params found');
//       setCustomFilterUrl(_url[1],()=>{
//         console.log('ssssssss')
//       })
//     }
//     fetch(`${apiUrl}/${resource}_csv?${customFilterUrl}`, options)
//       .then(res => {
//           return res.json();
//       }).then(jsonD => {
//         console.log('jsonD VVVVVVx===>', jsonD.data);
//         const msg = jsonD.data? jsonD.data[0].message : '';
//         setModalShow(true);
//         setModalMsg(msg);
//       });
//   }
//   const exporterModal = () => {
//     return ''
//   }

//   const onClose = () => {
//     setModalShow(false)
//   }
//   return (
//     <React.Fragment>
//     <TopToolbar>
//       {filters && cloneElement(filters, {
//         resource,
//         showFilter,
//         displayedFilters,
//         filterValues,
//         context: 'button',
//       })}
//       <RefreshButton />
//       <ExportButton
//         onClick={(e) => callExport(e)}
//         disabled={total === 0}
//         resource={csvResource}
//         sort={currentSort}
//         filter={{ ...filterValues, ...permanentFilter }}
//         exporter={exporterModal}
//         maxResults={maxResults}
//         />
//     </TopToolbar>
//     {
//           modalShow &&
//           <Modal open={modalShow} onClose={onClose} center> 
//             <h3>{modalMsg}</h3>
//           </Modal>
//     }
//     </React.Fragment>
//   )
// }

const ListActions = (props) => {

  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
    );


  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log('...', location.pathname, `${apiUrl}/${resource}_csv`)
    options.method = 'GET';
    let _url = location.pathname.split('?');
    if (_url.length > 1 && _url[1] !== '') {
      console.log('params found');
     setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    } else {
      setCustomFilterUrl(location.search)
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    }
  }
  const exporterModal = () => {
    return ''
  }

  const onClose = () => {
    setModalShow(false);
  }
    const { filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
    const csvResource = resource + '_csv'
    return (
      <React.Fragment>
        <TopToolbar>
          {filters && cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
          <RefreshButton />
          {/* <ExportButton
        onClick={(e) => this.callExport(e)}
        disabled={total === 0}
        resource={csvResource}
        sort={currentSort}
        filter={{ ...filterValues, ...permanentFilter }}
        exporter={this.exporterModal}
        maxResults={maxResults}
        /> */}
          <div>
            <button className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
        </TopToolbar>
        {
          modalShow &&
          <Modal open={modalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        }
      </React.Fragment>
    )
}

const BusinessesList = (props) => {
    const { permissions } = usePermissions();
    console.log("BusinessesList permissions",permissions)
    return (
      <React.Fragment>
        <Scrollbars className="scroll-container">
          <List {...props} 
          // exporter={this.exporter} 
          actions={<ListActions permissions={props} />} filters={<BusinessesFilter />} title="Sold Tos" >
            <Datagrid bulkActionButtons={false} rowClick="show" expand={(permissions === 'isSap' || permissions === 'isJDE') && <PostPanel contact_person={props.contact_person} permissions={permissions} />}>
              <TextField source="name" />
              <TextField source="phone" />
              <TextField source="sap_code" label="Sold To ID" />
              <TextField label="Digital Order Balance" source="sap_digital_order_balance" />
              <TextField source="orders_not_invoiced_price" />
              <DateField source="last_seen_at" showTime />
              <BooleanField label="Blocked" source="is_sap_blocked" />
              <BooleanField label="Deleted" source="is_sap_deleted" />
              <BooleanField label="Ordering Blocked" source="is_ordering_blocked" />
              <ShowButton />
            </Datagrid>
          </List>
        </Scrollbars>
      </React.Fragment>
    )
}

export default BusinessesList;